import { occFetch, occUrl } from "~/app/api/occ/occFetch";

export const resendUserEmail = async (email: string): Promise<Response> => {
  const response = await occFetch(occUrl(`/registered-user/resend-mail/${encodeURIComponent(email)}`));

  if (!response.ok) {
    throw new Error("Error status: " + response.status + ", please try again");
  }

  return response;
};
